"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDate;
function isDate(date) {
  return date instanceof Date && !isNaN(date.getTime());
}